import { render, staticRenderFns } from "./publishAdd.vue?vue&type=template&id=4423eb24&"
import script from "./publishAdd.vue?vue&type=script&lang=js&"
export * from "./publishAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports